/* istanbul ignore file */
import { singleSpaLit } from '../../common'
import { html } from 'lit-element'
import { GOTO_ROOT_SELECTOR } from '../../common/container'

export default singleSpaLit({
  template: () => html`<goto-calendar-connected></goto-calendar-connected>`,
  domElement: GOTO_ROOT_SELECTOR,
})
